import React, {useEffect, useState} from 'react';

import People from '../../../../../assets/svgComponents/People';
import ToolTipComponent from '../../toolTipComponent';

import utilsService from '../../../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './widgetPillComponent.css';

const WidgetPillComponent = ({
  hideToolTip = false,
  isChatUI = false,
  isDisabled = false,
  hideWidgetImage = false,
  hideWidgetName = false,
  toolTipPosition = 'right',
  widgetAppCtrlDto = {},
}) => {
  const [showToolTip, setShowToolTip] = useState(false);
  const [toolTipTxt, setToolTipTxt] = useState('');

  useEffect(() => {
    const toolTipTxt = `Widget name: ${widgetAppCtrlDto?.name?.toUpperCase()}`;
    setToolTipTxt(toolTipTxt);
  }, [widgetAppCtrlDto?.name]);

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  const getPhotoManipulatedUrl = () => {
    const widgetProfilePhotoDto =
      utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
        widgetAppCtrlDto.photoDtos,
        VIDABOO_CONSTANTS.PHOTO_TYPES.PROFILE,
        VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.WIDGET,
      )?.photoDto;
    const manipulationString = 'q_auto:eco,c_fit,h_50,w_50';
    const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
      widgetProfilePhotoDto,
      manipulationString,
    );
    return manipulatedPhotoUrl;
  };
  const photoUrl = getPhotoManipulatedUrl();

  return (
    <div
      className={`et-v2-widget-pill-container ${isDisabled ? 'et-v2-widget-pill-container-disabled' : ''} ${isChatUI ? 'et-v2-widget-pill-container-chat' : ''}`}>
      {!hideWidgetImage && (
        <div
          className="et-v2-wpc-img-tooltip-wrap"
          onMouseEnter={handleToolTip}
          onMouseLeave={handleToolTip}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="photo"
              className="et-v2-wpc-img-wrap-image"
            />
          ) : (
            <div className="et-v2-wpc-default-icon-name-wrap">
              {isChatUI ? (
                <div className="et-v2-wpc-default-icon-chat-name">
                  {widgetAppCtrlDto?.name?.toUpperCase()?.slice(0, 3)}
                </div>
              ) : (
                <People peopleCount={2} />
              )}
            </div>
          )}
          {showToolTip && !hideToolTip && (
            <ToolTipComponent
              toolTipPosition={toolTipPosition}
              toolTipTxt={toolTipTxt}
            />
          )}
        </div>
      )}

      {!hideWidgetName && (
        <div
          className="et-v2-wpc-default-icon-name"
          onMouseEnter={!hideToolTip && hideWidgetImage ? handleToolTip : null}
          onMouseLeave={!hideToolTip && hideWidgetImage ? handleToolTip : null}>
          {widgetAppCtrlDto?.name?.toUpperCase()}
          {/* if hideWidgetImage is false then tooltip will be shown on image else on widget name */}
          {hideWidgetImage && showToolTip && !hideToolTip && (
            <ToolTipComponent
              toolTipPosition={toolTipPosition}
              toolTipTxt={toolTipTxt}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default WidgetPillComponent;
